import { Col, PageWrapper, Row } from '@qonsoll/react-design'

import { HeaderBreadcrumbs } from 'components'
import { EditorAdvancedForm } from 'domains/Editor/components'
import { useEditorBaseActions } from 'domains/Editor/hooks'
import { useTranslations } from 'contexts/Translation'

const EditorCreatePage = (props) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting base actions for page */
  const { onBack } = useEditorBaseActions()

  /* Configuring page header */
  const headingProps = {
    title: t('Editor create'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  return (
    <PageWrapper
      onBack={onBack}
      breadcrumbs={<HeaderBreadcrumbs />}
      headingProps={headingProps}>
      <Row noGutters>
        <Col cw={[12, 12, 10, 8, 7]}>
          <EditorAdvancedForm />
        </Col>
      </Row>
    </PageWrapper>
  )
}

export default EditorCreatePage
